import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useGetPublicArtifactQuery } from "~/ui-rtk/api/companyArtifactApi"
import { Loader } from "~/ui-rtk/components/ui/common"
import ArtifactFrame from "./ArtifactFrame"

/**
 * Login-free view of a PUBLIC artifact (`/share/artifacts/:token`). The page
 * renders in the same sandboxed, CSP-wrapped frame as in the app; nothing of
 * the app shell, session or company is on this page.
 */
export default function PublicArtifactPage() {
  const { token = "" } = useParams()
  const { data, isLoading, error } = useGetPublicArtifactQuery(token, {
    skip: !token,
  })

  useEffect(() => {
    if (data?.title) document.title = data.title
  }, [data?.title])

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-basic-black">
        <Loader size={50} />
      </div>
    )
  }
  if (error || !data) {
    return (
      <div className="h-screen flex items-center justify-center bg-basic-black text-system-gray-400">
        This page does not exist or is no longer shared.
      </div>
    )
  }

  return (
    <div className="h-screen flex flex-col bg-basic-black">
      <div className="flex-1 min-h-0">
        <ArtifactFrame html={data.html} title={data.title} />
      </div>
    </div>
  )
}
